import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { BreakableText } from "@design-system/BreakableText/BreakableText";

interface Props {
    row: {
        original: {
            isGroupRow?: boolean;
            name: string;
            skipReason?: string | null;
        };
    };
    getValue: () => unknown;
}

export const TaskPreviewNameCell = ({ row, getValue }: Readonly<Props>) => {
    if (row.original.isGroupRow) {
        return (
            <ViewTableCell captureClicks>
                <strong>{row.original.name}</strong>
            </ViewTableCell>
        );
    }
    const { skipReason } = row.original;
    if (skipReason) {
        return (
            <ViewTableCell>
                <Tooltip content={skipReason}>
                    <span style={{ opacity: 0.4 }}>{String(getValue())}</span>
                </Tooltip>
            </ViewTableCell>
        );
    }
    return (
        <ViewTableCell>
            <BreakableText text={getValue() as string} showTooltip />
        </ViewTableCell>
    );
};
